import React from 'react';
import { render, screen, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Alert from './alert';

describe('Alert', () => {
  test('renders Alert component', async () => {
    render(<Alert message="テストメッセージ"/>);
    //screen.debug();

    expect(screen.getByText('テストメッセージ')).toBeInTheDocument();
  });
});
